export const SN_SET_SIDEBAR = 'SN_SET_SIDEBAR';
export const SN_SET_VIEW = 'SN_SET_VIEW';
export const SN_SET_FILTERS = 'SN_SET_FILTERS';
export const SN_SET_FILTERS_DATA = 'SN_SET_FILTERS_DATA';
export const SN_SET_FILTERS_LOADING = 'SN_SET_FILTERS_LOADING';
export const SN_SET_DATA = 'SN_SET_DATA';
export const SN_SET_LOADING = 'SN_SET_LOADING';
export const SN_SET_MODAL_LIST = 'SN_SET_MODAL_LIST';
export const SN_SET_MODAL_LIST_LOCATIONS = 'SN_SET_MODAL_LIST_LOCATIONS';
